module.exports = __webpack_public_path__ + "img/Image -3.f3ad1a4e.svg";